import { useState, useEffect } from 'react'
import { ApiGateway } from '../config/config'
import axios from 'axios'
import { getToken } from './auth'


class RoleService {
  static #instanceRequest = false
  static #roleServiceInstance = undefined
  #queued = false

  constructor() {
    if (!RoleService.#instanceRequest) {
      throw new TypeError('Cannot be constructed. Please use RoleService.getInstance()')
    }
    RoleService.#instanceRequest = false
  }

  static getInstance() {
    if (! RoleService.#roleServiceInstance) {
      RoleService.#instanceRequest = true
      RoleService.#roleServiceInstance = new RoleService()
    }
    return RoleService.#roleServiceInstance
  }

  #getMaxPrivelege(roles) {
    const maxPrivelege = roles.reduce((p,c) => {
      c = getRoleById(c.id)
      if (c && (!p || p.id > c.id)) {
        return c
      }
      return p
    }, null)
    return maxPrivelege
  }

  async getUserRole(msalInstance) {
    if (this.#queued) {
      return
    }
    this.#queued = true
    try {
      const token = await getToken()
      const koId = token?.idTokenClaims?.koId
      if (!koId) return undefined

      const basePath = `${ApiGateway.profile}/${koId}`
      const options = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token.idToken}`
        }
      }
      const response = await axios.get(basePath, options)
      let _role = undefined
      if (response.data) {
        _role = this.#getMaxPrivelege(response.data.roles)
      }

      return _role
    } finally {
      this.#queued = false
    }
  }
}

export const ROLES = {
  ADMIN: {id: 1, name: 'Admin'}, //super admin
  SRA_ADMIN: {id: 4, name: 'SRA Admin'}, //can manage users
  SRA_USER: {id: 5, name: 'SRA User'}, //can edit sra material
  LDS_VIEWER: {id: 14, name: 'LDS Viewer'} // can view LDS records
}

export const getRoleById = (id) => {
  return Object.values(ROLES).find(r => r.id === id)
}

function getStorageKeyName() {
  const ds = new Date().toLocaleDateString()
  return btoa(ds)
}
function getRoleEncoded(rob) {
  const enc = btoa(JSON.stringify(rob))
  return enc
}

function getStoredRole() {
  const encodedRole = window.sessionStorage.getItem(getStorageKeyName())
  if (encodedRole == null) {
    return null
  }
  const dec = atob(encodedRole)
  const rob = JSON.parse(dec)
  return rob
}
function serializeRole(role_ob) {
  window.sessionStorage.setItem(getStorageKeyName(),getRoleEncoded(role_ob))
}

export function cleanup() {
  window.sessionStorage.removeItem(getStorageKeyName())
}

export function useRole() {
  // const { instance } = useMsal()
  const [role, setRole] = useState()
  const instance = undefined

  async function getAccountRole() {
    if (!role) {
      const storedRole = getStoredRole()
      if (storedRole === null) {
        const _role = await RoleService.getInstance().getUserRole(instance)
        if (_role) {
          setRole(_role)
          serializeRole(_role)
          return _role
        } else {
          setRole(undefined)
          return undefined
        }
      } else {     
        setRole(storedRole)
        return storedRole
      }
    }
  }

  const hasRole = (roles) => {
    let _roles
    if (Array.isArray(roles)) {
      _roles = roles
    } else if (typeof roles === 'object') {
      _roles = [roles]
    }
    return role && _roles.some((r) => r?.id === role?.id)
  }

  const hasAnyRole = () => {
    return role && Object.values(ROLES).some((r) => r?.id === role?.id)
  }

  const clearRoleCache = () => {
    window.sessionStorage.removeItem(getStorageKeyName())
  }

  // getAccountRole()

  useEffect(() => {
    if (!role) {
      (async () => {
        await getAccountRole()
      })()
    }
  })

  return {
    role,
    hasRole,
    hasAnyRole,
    cleanup: clearRoleCache
  }
}